import { render, staticRenderFns } from "./SCardFeeTypeComp.vue?vue&type=template&id=2d7f8e04&"
import script from "./SCardFeeTypeComp.vue?vue&type=script&lang=js&"
export * from "./SCardFeeTypeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports